import clsx from "clsx";
import React from "react";

function IconText(props) {
  const {
    icon,
    text,
    wrapperClassName,
    iconPosition = "left",
    iconClassName,
    textClassName,
    iconSize = "small",
    iconVariant,
    subText = "",
  } = props;

  const ICON_SIZE_CLASS = {
    small: "md:h-[48px] md:w-[48px]",
    large: "md:h-[72px] md:w-[72px]",
  };
  const ICON_SIZE_SM_CLASS = {
    small: "h-[36px] w-[36px]",
    large: "h-[72px] w-[72px]",
  };

  const baseSizeClass = ICON_SIZE_CLASS[iconSize];
  const smOverrideClass = ICON_SIZE_SM_CLASS[iconSize];

  return (
    <div
      className={clsx(
        "flex items-center gap-4",
        wrapperClassName,
        iconPosition === "top" && "flex-col",
        iconPosition === "right" && "flex-row-reverse",
        iconPosition === "bottom" && "flex-col-reverse",
      )}
    >
      {icon && (
        <span
          className={clsx(
            "flex shrink-0 items-center justify-center",
            "rounded-[6px]",
            baseSizeClass,
            smOverrideClass,
            iconVariant === "transparent"
              ? "bg-transparent"
              : "bg-background-global rounded-[6px]",
            iconClassName,
          )}
        >
          {icon}
        </span>
      )}
      <div className="flex flex-col gap-1">
        <span
          className={clsx("text-lg leading-[26px] font-medium", textClassName)}
        >
          {text}
        </span>
        {subText && (
          <span className={clsx("leading-[21px] font-normal", textClassName)}>
            {subText}
          </span>
        )}
      </div>
    </div>
  );
}

export default IconText;
